import { render, staticRenderFns } from "./my-footer.vue?vue&type=template&id=71c262f2&scoped=true"
import script from "./my-footer.vue?vue&type=script&lang=js"
export * from "./my-footer.vue?vue&type=script&lang=js"
import style0 from "./my-footer.vue?vue&type=style&index=0&id=71c262f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c262f2",
  null
  
)

export default component.exports